import { ServiceData, SlotService } from '../state/types';
import { mapToArray } from '..';
import { OfferedAsType } from '../mappers/serviceMapper/utils/payment.mapper';

const hasPricingPlanOnlyService = (
  serviceData?: ServiceData | null,
): boolean => {
  if (!serviceData?.slotServices) {
    return false;
  }

  return mapToArray<SlotService>(serviceData.slotServices).some(
    ({ service }) =>
      service.payment?.offeredAs?.length === 1 &&
      service.payment.offeredAs[0] === OfferedAsType.PRICING_PLAN,
  );
};

export const getIsCollectParticipantFormActive = (
  serviceData: ServiceData | null | undefined,
  isFeatureEnabled: boolean,
): boolean =>
  isFeatureEnabled &&
  !!serviceData?.collectParticipantForm &&
  (serviceData?.maxNumberOfParticipants ?? 0) > 1 &&
  !hasPricingPlanOnlyService(serviceData);
